import React, {memo} from 'react'
import PropTypes from 'prop-types'

/* Components */
import HbImageView from '../../../../components/HbImage/view/HbImageView'
import HbPlaceholderFrame from '../../../../components/Placeholder/frame/HbPlaceholderFrame'

/* Styles */
import s from './product-card.scss'

const ProductImage = memo(({imageUrl, incentiveToBuy, isAdProduct, isBot}) => {
  const replaceSizeInUrl = (url, size = '200-200') => {
    return url.replace('{size}', size)
  }

  return (
    <div className={s.productImageContainer}>
      <HbPlaceholderFrame ratio={1}>
        <HbImageView
          shouldLoadEagerly={isBot}
          className={s.productImage}
          image={{ src: replaceSizeInUrl(imageUrl, '200-200') }}
        />
        {incentiveToBuy && (
          <div className={s.yarinKapinda} aria-hidden='true'>
            <img src={incentiveToBuy?.imageUrl} alt={incentiveToBuy?.tagName} />
          </div>
        )}
      </HbPlaceholderFrame>
      {isAdProduct && <div className={s.productAdsArea}>Reklam</div>}
    </div>
  );
})

ProductImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  incentiveToBuy: PropTypes.shape({
    badgeImageUrl: PropTypes.string,
    tagName: PropTypes.string
  })
}

export default ProductImage
